import { render, staticRenderFns } from "./SocialInput.vue?vue&type=template&id=92863fee&scoped=true&"
import script from "./SocialInput.vue?vue&type=script&lang=js&"
export * from "./SocialInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92863fee",
  null
  
)

export default component.exports